import type { MRT_SortingState as SortingState } from "material-react-table";
import { useState } from "react";
import { OrderDirection } from "_shared/_api/ordering/order-direction";

/** The Name column's sort, A to Z, which every template panel opens on. */
const BY_NAME_ASCENDING: SortingState = [{ id: "name", desc: false }];

/**
 * The order a template panel's query asks for, kept with the `sorting` that `TemplateSelector`'s Name
 * header reads and sets. The panel loads its rows a part at a time as the reader scrolls, so the server
 * orders them: a sort of the rows in hand would put the next ones in the middle (#6862).
 */
export default function useTemplateNameOrder() {
  const [value, setValue] = useState<SortingState>(BY_NAME_ASCENDING);
  const orderDirection = value[0]?.desc ? OrderDirection.Descending : OrderDirection.Ascending;
  return { orderDirection, sorting: { value, onChange: setValue } };
}
